import { IconButton, styled } from '@mui/material';

export const OptionsButton = styled(IconButton)({ padding: 0 });
